import * as React from "react";
import { AppShape, DisclosureShape, HurdleShape } from "@eave/shared/types/api";
import HurdleView from "underwriter_dashboard/shared/HurdleView";
import { getFileDownloadBaseURL } from "config";
import { Button } from "react-bootstrap";

const styles = require("underwriter_dashboard/hurdle_editors/styles.module.scss");
const { FormattedDate } = require("react-intl");

interface Props {
  app: AppShape;
  hurdle: HurdleShape;
  onHide: Function;
}

class DisclosureRequestLintResultsEditor extends React.Component<Props, any> {
  render() {
    const { app, hurdle, onHide } = this.props;
    return (
      <HurdleView app={app} hurdle={hurdle} onHide={onHide}>
        <table className="table hurdles-editor__table">
          <thead>
            <tr>
              <th className="col-lg-2">Stage</th>
              <th className="col-lg-2">CreatedAt</th>
              <th className="col-lg-2">View Disclosure Request XML</th>
              <th className="col-lg-2">View Disclosure PDF</th>
              <th className="col-lg-4">Request XML Lint Results</th>
            </tr>
          </thead>
          <tbody>
            {app.disclosures &&
              app.disclosures.map((disclosure: DisclosureShape, index: number) => (
                <tr key={`disclosures_${index}`}>
                  <td>{disclosure.stage}</td>
                  <td>
                    <FormattedDate
                      value={disclosure.created_at}
                      year="numeric"
                      month="numeric"
                      day="numeric"
                      hour="numeric"
                      minute="numeric"
                    />
                  </td>
                  <td>
                    {disclosure.request_s3_key ? (
                      <a href={getFileDownloadBaseURL(disclosure.request_s3_key)}>Request XML</a>
                    ) : (
                      <span>No Request S3 Key</span>
                    )}
                  </td>
                  <td>
                    {disclosure.pdf_s3_key ? (
                      <a href={getFileDownloadBaseURL(disclosure.pdf_s3_key)}>PDF</a>
                    ) : (
                      <span>No Request S3 Key</span>
                    )}
                  </td>
                  <td>{disclosure.request_lint_results}</td>
                </tr>
              ))}
          </tbody>
        </table>

        <footer className={styles.footer}>
          <Button bsSize="small" onClick={onHide}>
            <i className="fa fa-thumbs-up" /> OK
          </Button>
        </footer>
      </HurdleView>
    );
  }
}

export default DisclosureRequestLintResultsEditor;
